// FNV-1a: lifted verbatim from tickets.js's `hash` — the same deterministic
// tie-break, exposed here so the engine (and anything importing it) can use it too.

/** 32-bit FNV-1a hash of a string. */
export function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
